// 通用接口
import request from '@/utils/request'
import qs from 'qs'

// ************************ 文件模块 *************************
// 获取语言种类列表
export const getLangType = (params: any = {}) =>
  request({
    url: '/app/language',
    method: 'get',
    params
  })

// 获取下架原因
export const getDownReason = () =>
  request({
    url: '/app/offlineReason',
    method: 'get'
  })

// 获取下架状态
export const getDownStatus = () =>
  request({
    url: '/app/offlineStatus',
    method: 'get'
  })

// IOS - 应用来源
export const getIosSource = () =>
  request({
    url: `/ios/source`,
    method: 'get'
  })
// Android - 应用来源
export const getAndroidSource = () =>
  request({
    url: `/android/source`,
    method: 'get'
  })

// 获取搜索渠道映射
export const getSearchCategory = (data: { isIos: boolean }) =>
  request({
    url: `/app/search_map`,
    method: 'get',
    params: data
  })

// 获取标签映射
export const getLabelMapping = () =>
  request({
    url: `/basicMaterial/tag/mapping`,
    method: 'get'
  })
// 获取角标映射
export const getTagMapping = () =>
  request({
    url: `/basicMaterial/subscript/mapping`,
    method: 'get'
  })
// 获取应用分类映射
export const getCatagoryMapping = () =>
  request({
    url: `/basicMaterial/categories`,
    method: 'get'
  })
// 获取应用分类映射
export const getAndroidCategories = () =>
  request({
    url: `/basicMaterial/androidCategories`,
    method: 'get'
  })

// ************************ 内容管理模块 *************************
// 获取渠道级联
export const getChannelOption = (data: { type: number, pos: string, pid: number }) =>
  request({
    url: `/channel/navi`,
    method: 'get',
    params: data
  })
// 修改渠道，banner，专题排序
export const setContentSeq = (data: { nid: number, relateId: number, seq: number }) =>
  request({
    url: `/app/changeSeq`,
    method: 'post',
    data: qs.stringify(data)
  })

// 获取语言种类列表
export const getToken = () =>
  request({
    url: '/pic_anti/chaos',
    method: 'get'
  })
